import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Logo } from "@/components/Logo";

const STATIC = {
  brands: [
    { path: "/?join=brand", label: "Register as a brand" },
    { path: "/?join=brand", label: "Post a collaboration campaign" },
    { path: "/influencer-directory", label: "Browse the influencer directory" },
    { path: "/terms", label: "Escrow payments & terms" },
  ],
  creators: [
    { path: "/?join=creator", label: "Register as an influencer" },
    { path: "/?join=creator", label: "Join as a UGC creator or agency" },
    { path: "/influencer-directory", label: "See how creators are listed" },
    { path: "/privacy", label: "Profile privacy" },
  ],
};

function Col({ title, links, testid }) {
  if (!links?.length) return null;
  return (
    <div data-testid={testid}>
      <h3 className="font-heading font-bold text-sm mb-3">{title}</h3>
      <ul className="space-y-2">
        {links.map((l, i) => <li key={`${l.path}-${i}`}><Link to={l.path} className="text-sm text-muted-foreground hover:text-foreground">{l.label}</Link></li>)}
      </ul>
    </div>
  );
}

export function SeoFooter() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/seo/footer").then((r) => setD(r.data)).catch(() => setD({})); }, []);
  return (
    <footer className="relative z-10 border-t border-border mt-16 bg-background" data-testid="seo-footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-12">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8">
          <Col title="Popular categories" links={d?.categories} testid="footer-categories" />
          <Col title="Popular cities" links={d?.cities} testid="footer-cities" />
          <Col title="Browse by region" links={d?.regions} testid="footer-regions" />
          <Col title="Popular languages" links={d?.languages} testid="footer-languages" />
          <Col title="Popular platforms" links={d?.platforms} testid="footer-platforms" />
          <Col title="For brands" links={STATIC.brands} testid="footer-brands" />
          <Col title="For influencers & UGC creators" links={STATIC.creators} testid="footer-creators" />
        </div>
        {d?.popular?.length > 0 && (
          <div className="mt-10" data-testid="footer-popular">
            <h3 className="font-heading font-bold text-sm mb-3">Popular searches</h3>
            <ul className="flex flex-wrap gap-x-5 gap-y-2">
              {d.popular.map((l) => <li key={l.path}><Link to={l.path} className="text-sm text-muted-foreground hover:text-foreground">{l.label}</Link></li>)}
            </ul>
          </div>
        )}
        <Link to="/influencer-directory" data-testid="footer-view-all" className="inline-block mt-8 text-sm font-semibold text-brand-pink hover:opacity-80">View all influencer pages →</Link>
        <div className="mt-10 pt-8 border-t border-border flex flex-col sm:flex-row items-center justify-between gap-6">
          <Logo />
          <div className="flex items-center gap-6 text-sm text-muted-foreground">
            <Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-foreground">Privacy Policy</Link>
            <Link to="/terms" data-testid="footer-terms-link" className="hover:text-foreground">Terms of Service</Link>
          </div>
          <p className="text-sm text-muted-foreground">© 2026 InfluencerCollab.net — Brands meet Creators.</p>
        </div>
      </div>
    </footer>
  );
}
